module.exports = __webpack_public_path__ + "img/paid-plan.bbbdc456.jpg";